import React, { useMemo } from "react";

import { STANDALONE_CART_TYPE } from "../utils/consts";
import ClientSearchTab from '../pages/home-page/cart-standalone-side-bar/client-search-tab/client-search-tab';
import CartStandaloneTab from '../pages/home-page/cart-standalone-side-bar/cart-standalone-tab/cart-standalone-tab';
import { useCartStandaloneProvider } from '../pages/home-page/cart-standalone-side-bar/cart-standalone-provider/cart-standalone-provider';

const useStandaloneCartTabs = () => {
      const { selectedTab, navigateToStandaloneCartTab, standaloneCartProducts } = useCartStandaloneProvider();

      const tabs = useMemo(() => {
            const tabs = []

            tabs.push({
                  key: STANDALONE_CART_TYPE.INFO,
                  label: 'Info',
                  component: () => (
                        <ClientSearchTab
                              visible={selectedTab === STANDALONE_CART_TYPE.INFO}
                              navigateToStandaloneCartTab={navigateToStandaloneCartTab}
                        />
                  )
            })

            tabs.push({
                  key: STANDALONE_CART_TYPE.CART,
                  label: 'Cart',
                  products: standaloneCartProducts.length,
                  component: () => (
                        <CartStandaloneTab
                              copyLabel='Copy Standalone Cart'
                              visible={selectedTab === STANDALONE_CART_TYPE.CART}
                        />
                  )
            })

            return tabs
      }, [selectedTab, navigateToStandaloneCartTab, standaloneCartProducts.length]);

      return ({ tabs });
}

export default useStandaloneCartTabs;
